var map = {
	"./en/common.json": 4053,
	"./en/index_Banner.json": 4446,
	"./en/index_Components.json": 6967,
	"./en/index_Intros.json": 3888,
	"./en/index_JoinUs.json": 5586,
	"./en/shared_Drawer.json": 9756,
	"./en/shared_Header.json": 8181,
	"i18n/locales/en/common.json": 4053,
	"i18n/locales/en/index_Banner.json": 4446,
	"i18n/locales/en/index_Components.json": 6967,
	"i18n/locales/en/index_Intros.json": 3888,
	"i18n/locales/en/index_JoinUs.json": 5586,
	"i18n/locales/en/shared_Drawer.json": 9756,
	"i18n/locales/en/shared_Header.json": 8181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5937;